import { LogLevel } from "@azure/msal-browser";
function requireConfig(name, value) {
    if (!value) {
        throw new Error(`Missing required frontend config: ${name}`);
    }
    return value;
}
export const CLIENT_ID = requireConfig("CLIENT_ID", process.env.CLIENT_ID);
export const TENANT_ID = requireConfig("TENANT_ID", process.env.TENANT_ID);
export const ADDIN_BASE_URL = requireConfig("ADDIN_BASE_URL", process.env.ADDIN_BASE_URL);
export const SILENT_REDIRECT_PATH = "/auth/silent-redirect.html";
/**
 * Graph API scopes required by this add-in.
 * User.Read covers: GET /me (profile fields) and GET /me/photo/$value (profile photo).
 */
export const GRAPH_SCOPES = ["User.Read"];
export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: `${ADDIN_BASE_URL}${SILENT_REDIRECT_PATH}`,
        postLogoutRedirectUri: `${ADDIN_BASE_URL}/taskpane/index.html`,
    },
    cache: {
        // localStorage is shared across the task pane and event runtime pages,
        // which lets interactive consent in the task pane benefit later silent
        // token acquisition during compose events.
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii)
                    return;
                if (level === LogLevel.Error)
                    console.error("[MSAL]", message);
                else if (level === LogLevel.Warning)
                    console.warn("[MSAL]", message);
                else if (level === LogLevel.Info)
                    console.info("[MSAL]", message);
            },
            logLevel: LogLevel.Warning,
        },
    },
};
